module.exports = __webpack_public_path__ + "static/media/more-rounded.c502167b.svg";